import { StandardEvents } from '@shopify/events';

class MakerIsFitSummary extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const section = this.closest('.shopify-section');
    section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && detail.productId !== this.dataset.productId) return;

        const updatedSummary = detail.html.querySelector(
          `maker-is-fit-summary[data-block-id="${CSS.escape(this.dataset.blockId ?? '')}"]`
        );

        if (!(updatedSummary instanceof HTMLElement)) return;

        this.replaceChildren(...Array.from(updatedSummary.childNodes, (node) => node.cloneNode(true)));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[maker-is-fit-summary] Variant update rejected:', error);
        }
      });
  };
}

if (!customElements.get('maker-is-fit-summary')) {
  customElements.define('maker-is-fit-summary', MakerIsFitSummary);
}
